export default __webpack_public_path__ + "static/media/ic-linked.647cee77.svg";